import { createContext, useState, useEffect } from "react";

const ParamsContext = createContext({});

export const ParamsProvider = ({ children }) => {
  const [globalparams, setGlobalParams] = useState({
    InterestRate: 0.1,
    Tolerance: 0.1,
    Legal: 1.5,
    CPTInsuranceRate: 0.0007,
    CIPInsuranceRate: 0.0014,
    DAPInsuranceRate: 0.0011,
    CIPInsuranceFactor: 1.1,
    HarborFeePct: 0.00125,
    MerchProcFeePct: 0.003464,
  });

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const resp = await fetch("https://api.frankfurter.dev/v1/latest?base=USD&symbols=EUR");
        const json = await resp.json();
        const rate = json.rates.EUR;
        if (rate && typeof rate === "number") {
          setGlobalParams((prev) => ({
            ...prev,
            exchangeRateUsdToEur: rate,
          }));
        } else {
          console.warn("Unexpected rate response:", json);
        }
      } catch (err) {
        console.error("Exchange rate fetch failed:", err);
      }
    };

    fetchRate();
  }, []);

  return <ParamsContext.Provider value={{ globalparams, setGlobalParams }}>{children}</ParamsContext.Provider>;
};

export default ParamsContext;
